import { Component, inject } from '@angular/core';
import { ThemingService } from '../../theming.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-success-view',
  imports: [TranslocoPipe],
  templateUrl: './success-view.component.html',
  styleUrl: './success-view.component.scss',
})
export class SuccessViewComponent {
  public readonly themingService = inject(ThemingService);
}
